/**
 * Import job status enum
 */
var ImportJobStatus;
(function (ImportJobStatus) {
    ImportJobStatus["PENDING"] = "PENDING";
    ImportJobStatus["PROCESSING"] = "PROCESSING";
    ImportJobStatus["COMPLETED"] = "COMPLETED";
    ImportJobStatus["FAILED"] = "FAILED";
})(ImportJobStatus || (ImportJobStatus = {}));
/**
 * Import target enum - what type of data is being imported
 */
var ImportTarget;
(function (ImportTarget) {
    ImportTarget["INVENTORY"] = "INVENTORY";
})(ImportTarget || (ImportTarget = {}));

export { ImportJobStatus, ImportTarget };
//# sourceMappingURL=ImportJob.js.map
